import { approvalMatrixApi } from "@/main/api";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { TextEllipsis } from "@/main/components/shared/styles";
import { ApprovalMatrixFilterRequest } from "@/main/models/request";
import { ApprovalMatrixSearchResponse } from "@/main/models/response";
import RowApprovalMatrix from "@/main/screens/registration/approvalMatrix/gridApprovalMatrix/rowApprovalMatrix";
import { isNullUndefined } from "@/main/services/reducerUtils";
import { getTranslateByKey } from "@/main/services/utils";
import { Dispatch, SetStateAction, useCallback } from "react";
import * as S from "./styles";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";

interface IGridApprovalMatrix {
	filter: ApprovalMatrixFilterRequest | null;
	dataGrid: ApprovalMatrixSearchResponse[];
	setDataGrid: Dispatch<SetStateAction<ApprovalMatrixSearchResponse[]>>;
}

export default function GridApprovalMatrix({ dataGrid, filter, setDataGrid }: Readonly<IGridApprovalMatrix>) {
	const fetchData = useCallback(async (request: ApprovalMatrixFilterRequest) => {
		const response = await approvalMatrixApi.searchGrid(request);
		return response.data;
	}, []);

	const rowHeaders = [
		<TextEllipsis key={0}>{getTranslateByKey("information.insurer")}</TextEllipsis>,
		<TextEllipsis key={1}>{getTranslateByKey("information.matrixName")}</TextEllipsis>,
		<TextEllipsis key={2}>{getTranslateByKey("information.approvalMatrixType")}</TextEllipsis>,
		<TextEllipsis key={3}>{getTranslateByKey("information.status")}</TextEllipsis>,
	];

	if (isNullUndefined(filter)) return null;

	return (
		<S.Container>
			<KOGPaginationGrid<ApprovalMatrixSearchResponse, ApprovalMatrixFilterRequest>
				showTitleResults
				dataGrid={dataGrid}
				formFilters={filter}
				setDataGrid={setDataGrid}
				fetchEqualFilters
				fetchMore={fetchData}
			>
				<BoxGrid rowHeaders={rowHeaders} sizeColumns={["20%", "20%", "20%", "7%"]}>
					{dataGrid.map((item, index) => (
						<RowApprovalMatrix key={item.approvalMatrixGuid} index={index} item={item} />
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}
